import { useGetNationsQuery } from "../store/services/ProvinceService";

export const NazioniList = () => {
    const {data}: any = useGetNationsQuery('');
    return data?.map((nazione: any) => ({value: nazione?.codice, label: nazione?.nome}))
};